import { render } from "./index.vue?vue&type=template&id=2c45bcd2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2c45bcd2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c45bcd2"]])

export default __exports__